import {
  updateStateAfterWidgetOptionChange,
  isMdaeWidgetOptionChangeEvent,
  asyncActionsInProgress,
} from "./mdae-framework";
import { cloneDeep } from "lodash";
const SHOW_LOADER = "SHOW_LOADER";
const HIDE_LOADER = "HIDE_LOADER";
const TOGGLE_NOTIFY_POPUP = "TOGGLE_NOTIFY_POPUP";
const TOGGLE_CONFIRMATION_POPUP = "TOGGLE_CONFIRMATION_POPUP";
const ADD_DATA_UPDATERS_FOR_WIDGETS = "ADD_DATA_UPDATERS_FOR_WIDGETS";
const REMOVE_DATA_UPDATERS_OF_WIDGETS = "REMOVE_DATA_UPDATERS_OF_WIDGETS";
const SHOW_CONFIRMAION_WINDOW = "SHOW_CONFIRMAION_WINDOW";
const SET_GENERIC_DATAGRID_SELECTED_ROW_ID = "SET_GENERIC_DATAGRID_SELECTED_ROW_ID";
export const TOGGLE_PROGRESS_LOAD_INDICATOR = "TOGGLE_PROGRESS_LOAD_INDICATOR";
export const SET_PROGRESS_LOAD_INDICATOR_VALUE =
  "SET_PROGRESS_LOAD_INDICATOR_VALUE";
export {
  SHOW_LOADER,
  HIDE_LOADER,
  ADD_DATA_UPDATERS_FOR_WIDGETS,
  REMOVE_DATA_UPDATERS_OF_WIDGETS,
  SHOW_CONFIRMAION_WINDOW,
  TOGGLE_NOTIFY_POPUP,
  TOGGLE_CONFIRMATION_POPUP,
  SET_GENERIC_DATAGRID_SELECTED_ROW_ID
};


const confirmationPopupDefaultOptions = {
  autoHeight: false
}

const initialState = {
  showCommonLoader: false,
  isDisableFocusState: false,
  widgetOptionUpdator: {},
  notifyPopupConfig: {
    width: 600,
    height: 250,
  },
  isManualLoaderShown: false,
  isHideManualLoader: false,
  genericDataGridSelectedRowId: -1
};

const addWidgetDataUpdater = (state, action) => {
  const widgetUpdaterData = action.widgetUpdaterData;
  if (widgetUpdaterData && widgetUpdaterData.length) {
    for (let i = 0; i < widgetUpdaterData.length; i++) {
      let currentData =
        state.widgetOptionUpdator[widgetUpdaterData[i].actionType];
      currentData = currentData ? currentData : {};

      currentData[action.mdaeDxWidgetIdentifier] = currentData[
        action.mdaeDxWidgetIdentifier
      ]
        ? currentData[action.mdaeDxWidgetIdentifier]
        : [];

      currentData[action.mdaeDxWidgetIdentifier].push(widgetUpdaterData[i]);

      state.widgetOptionUpdator[widgetUpdaterData[i].actionType] = currentData;
    }
  }

  return {
    ...state,
  };
};

const removeWidgetDataUpdater = (state, action) => {
  const widgetUpdaterData = action.widgetUpdaterData;
  if (widgetUpdaterData && widgetUpdaterData.length) {
    for (let i = 0; i < widgetUpdaterData.length; i++) {
      delete state.widgetOptionUpdator[widgetUpdaterData[i].actionType][
        action.mdaeDxWidgetIdentifier
      ];
      if (
        state.widgetOptionUpdator[widgetUpdaterData[i].actionType] &&
        !Object.getOwnPropertyNames(
          state.widgetOptionUpdator[widgetUpdaterData[i].actionType]
        ).length
      )
        delete state.widgetOptionUpdator[widgetUpdaterData[i].actionType];
    }
  }

  return {
    ...state,
  };
};

export default function(state = initialState, action) {
  let newState;
  switch (action.type) {
    case SHOW_LOADER:
      return {
        ...state,
        showCommonLoader: true,
        isManualLoaderShown:
          typeof action?.data?.isManualLoaderShown === "boolean"
            ? action?.data?.isManualLoaderShown
            : state.isManualLoaderShown,
        isDisableFocusState: action?.data?.isDisableFocusState || false,
      };
    case HIDE_LOADER:
      var propList = Object.getOwnPropertyNames(asyncActionsInProgress);
      let isHideLoader = !propList?.length;
      if (state.isManualLoaderShown) {
        isHideLoader = action?.data?.isHideManualLoader;
      }
      if (isHideLoader)
        return {
          ...state,
          showCommonLoader: false,
          isManualLoaderShown: false,
          isHideManualLoader: false,
          isDisableFocusState: action?.data?.isDisableFocusState || false,
        };
      return { ...state };
    case TOGGLE_NOTIFY_POPUP:
      newState = cloneDeep(state);
      if (isMdaeWidgetOptionChangeEvent(action.data)) {
        newState = updateStateAfterWidgetOptionChange(newState, action.data);
      } else {
        const notifyPopupConfig = newState.notifyPopupConfig;
        for (let prop in action.data) {
          notifyPopupConfig[prop] = action.data[prop];
        }
        newState = { ...newState, notifyPopupConfig: notifyPopupConfig };
      }
      return newState;
    case TOGGLE_CONFIRMATION_POPUP:
      newState = cloneDeep(state);
      if (isMdaeWidgetOptionChangeEvent(action.data)) {
        newState = updateStateAfterWidgetOptionChange(newState, action.data);
      } else {
        const confirmationPopupConfig = newState.confirmationPopupConfig
          ? newState.confirmationPopupConfig
          : {};
        const confirmationPopupConfigsToSet = {
          ...confirmationPopupDefaultOptions,
          ...action.data,
        };
        for (let prop in confirmationPopupConfigsToSet) {
          confirmationPopupConfig[prop] = confirmationPopupConfigsToSet[prop];
        }
        newState = {
          ...newState,
          confirmationPopupConfig: confirmationPopupConfig,
        };
      }
      return newState;
    case SET_GENERIC_DATAGRID_SELECTED_ROW_ID:
      return {
        ...state,
        genericDataGridSelectedRowId: action.genericDataGridSelectedRowId,
      };
    case ADD_DATA_UPDATERS_FOR_WIDGETS:
      return addWidgetDataUpdater(state, action);
    case REMOVE_DATA_UPDATERS_OF_WIDGETS:
      return removeWidgetDataUpdater(state, action);
    case TOGGLE_PROGRESS_LOAD_INDICATOR:
      return {
        ...state,
        isProgressLoadIndicatorVisible: action.isVisible,
        progressLoadIndicatorProgressText:
          action.progressLoadIndicatorProgressText,
        progressLoadIndicatorShowAIIcon: action.progressLoadIndicatorShowAIIcon ?? false,
      };
    case SET_PROGRESS_LOAD_INDICATOR_VALUE:
      return {
        ...state,
        progressLoadIndicatorValue: action.progressLoadIndicatorValue,
      };
    default:
      return state;
  }
}
